import { Constructor } from '@angular/cdk/table';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IExternalLink } from 'src/app/core/models/i-external-link';
import { compareArrays } from '../utils/array-utils';

type WithExternalLinksFormSectionType = {
  _initExternalLinks(externalLinks: IExternalLink[]): void;
  _initExternalLinksValueChanges(
    getPreviousSelectedValue: () => IExternalLink[] | null
  ): void;
  _buildExternalLinks(): IExternalLink[];
  get externalLinks(): IExternalLink[];
};

type ExternalLinksFormSectionRequerimentsBase = {
  form: FormGroup;
  FORM_PATHS: { EXTERNAL_LINKS: () => string };
  destroy$: Subject<boolean>;
};

export function WithExternalLinksFormSection<
  TBase extends Constructor<ExternalLinksFormSectionRequerimentsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithExternalLinksFormSectionType;
  prototype: WithExternalLinksFormSectionType;
} & TBase {
  return class WithExternalLinksFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initExternalLinks(externalLinks: IExternalLink[]): void {
      externalLinks.forEach((link) => {
        (
          this.form.get(this.FORM_PATHS.EXTERNAL_LINKS()) as FormArray<
            FormControl<IExternalLink>
          >
        ).push(new FormControl(link));
      });
      this.form.get(this.FORM_PATHS.EXTERNAL_LINKS()).markAsPristine();
    }

    _initExternalLinksValueChanges(
      getPreviousSelectedValue: () => IExternalLink[] | null
    ): void {
      this.form
        .get(this.FORM_PATHS.EXTERNAL_LINKS())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (compareArrays(newValue, getPreviousSelectedValue())) {
              this.form.get(this.FORM_PATHS.EXTERNAL_LINKS()).markAsPristine();
            } else {
              this.form.get(this.FORM_PATHS.EXTERNAL_LINKS()).markAsDirty();
            }
          },
        });
    }

    _buildExternalLinks(): IExternalLink[] {
      return this.form.get(this.FORM_PATHS.EXTERNAL_LINKS()).value;
    }

    get externalLinks(): IExternalLink[] {
      return this.form.get(this.FORM_PATHS.EXTERNAL_LINKS()).value;
    }
  };
}
